{
    "TargetreportformatLabel": "Formato do relatório de destino:",
    "TargetreportformatPdfOptionLabel": "Documento PDF",
    "TargetreportformatRtfOptionLabel": "Documento RTF",
    "TargetreportformatCsvOptionLabel": "Exportação CSV",
    "UselanguageLabel": "Usar idioma:",
    "UselanguageEnusOptionLabel": "Inglês dos Estados Unidos)",
    "UselanguageEngbOptionLabel": "Inglês (Reino Unido)",
    "PapersizeLabel": "Tamanho do papel:",
    "PapersizeA4OptionLabel": "A4 (210 mm x 297 mm)",
    "PapersizeLegalOptionLabel": "Legal (8½\" x 14\")",
    "PapersizeLetterOptionLabel": "Carta (8½\" x 11\")",
    "Format_SectionHeader": "Formato",
    "NAME": "Format",
    "TargetreportformatXlsOptionLabel": "Exportação XLS"
}